import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPicture = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-1 -1 22 22",
	fill: "none",
	stroke: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.46 6.149L19.46 14.3C19.46 17.32 17.57 19.45 14.55 19.45L5.9 19.45C2.88 19.45 1 17.32 1 14.3L1 6.149C1 3.129 2.89 1 5.9 1L14.55 1C17.57 1 19.46 3.129 19.46 6.149Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.53125 14.6807L5.05925 13.0677C5.59025 12.5047 6.47525 12.4777 7.03925 13.0077C7.05625 13.0247 7.97625 13.9597 7.97625 13.9597C8.5313 14.5247 9.4383 14.5337 10.0033 13.9797C10.0403 13.9437 12.3372 11.1577 12.3372 11.1577C12.9292 10.4387 13.9922 10.3357 14.7122 10.9287C14.7602 10.9687 16.9303 13.1957 16.9303 13.1957",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.56272 7.38291C8.56272 8.35192 7.77769 9.13692 6.80869 9.13692C5.83969 9.13692 5.05469 8.35192 5.05469 7.38291C5.05469 6.41391 5.83969 5.62891 6.80869 5.62891C7.77769 5.62991 8.56272 6.41391 8.56272 7.38291Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPicture;
